import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

export enum PaddingContainerModifier {
  NO_PADDING_TOP = 'no-padding-top',
  NO_PADDING_RIGHT = 'no-padding-right',
  NO_PADDING_BOTTOM = 'no-padding-bottom',
  NO_PADDING_LEFT = 'no-padding-left',
}

type BaseProps = {
  modifier?: Modifier<PaddingContainerModifier>;
};

type DivProps = BaseProps & {
  children: React.ReactNode;
};

type SpanProps = BaseProps & {
  children: React.ReactNode;
};

export function PaddingContainerDiv({ modifier, children }: PropsWithChildren<DivProps>) {
  return <div className={bem('padding-container', modifier)}>{children}</div>;
}

export function PaddingContainerSpan({ modifier, children }: PropsWithChildren<SpanProps>) {
  return <span className={bem('padding-container', modifier)}>{children}</span>;
}
